import { render, staticRenderFns } from "./SurveyVoucher.vue?vue&type=template&id=7b20220e&scoped=true&"
import script from "./SurveyVoucher.vue?vue&type=script&lang=ts&"
export * from "./SurveyVoucher.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyVoucher.vue?vue&type=style&index=0&id=7b20220e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b20220e",
  null
  
)

export default component.exports